﻿/*
--------------------------------------------------------------------------------
 Exit popup
--------------------------------------------------------------------------------
*/

import "../Styles/exitpopup.css";

(function ($) {

    'use strict';

    var self,
        EXIT_POPUP_CLOSED_COOKIE = "ExitPopupClosed",
        OPPORTUNITY_EXITPOPUP_FORM = "#opportunity-exit-popup-form",
        EXIT_POPUP_SEND_BUTTON = "#opportunity-exit-popup-send-button",
        EXIT_POPUP_EMAIL = '#exit-popup-email',
        EXIT_POPUP_WINDOW = "#ExitPopupWindow",
        $exitPopopWindow;

    function gtmStatistic() {
        if (typeof ori.dataLayer !== "undefined") {
            ori.dataLayer.push({
                'eventAction': 'popupDisplayed',
                'event': 'exitIntent'
            });

            $(EXIT_POPUP_SEND_BUTTON).click(function () {
                ori.dataLayer.push({
                    'eventAction': 'SendButtonClicked',
                    'event': 'exitIntent'
                });
            });
        }
    }

    function setCookie() {
        $.cookie(EXIT_POPUP_CLOSED_COOKIE, true, { expires: 360 });
    }

    function showExitPopup() {
        $exitPopopWindow.open();
        var $exitPopupEmail = $(EXIT_POPUP_EMAIL);
        if ($exitPopupEmail.val() === '') {
            $exitPopupEmail.data('kendoTextBox')._placeholder();
        }
        $(OPPORTUNITY_EXITPOPUP_FORM).on(self.eventString("submit"), function(e) {
            setCookie();
        });
        gtmStatistic();
    }

    function initExitPopup() {
        jQuery(document).mouseleave(function() {
            if (!$.cookie(EXIT_POPUP_CLOSED_COOKIE) && !$exitPopopWindow.options.visible) {
                showExitPopup();
            }
        });
    }

    ori.popup.addModule("exitPopup", {
        init: function(options) {
            if ($.cookie(EXIT_POPUP_CLOSED_COOKIE)) return;
            $exitPopopWindow = $(EXIT_POPUP_WINDOW).data("kendoWindow");
            setTimeout(initExitPopup, options.timeOut);
        },
        closeExitPopup: function () {
            setCookie();
        }
    });
    self = ori.popup.exitPopup;
})(jQuery);